import React, { useState } from "react";
import "./Contact.css";

function Contact({ darkMode }) {
    const [result, setResult] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        setResult("Sending message...");

        const formData = new FormData(e.target);

        const object = Object.fromEntries(formData);
        const json = JSON.stringify(object);

        try {
            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: json,
            });

            const data = await response.json();

            if (response.status === 200) {
                setResult("Message sent successfully.");
                e.target.reset();
            } else {
                setResult(data.message);
            }
        } catch (error) {
            console.error(error);

            setResult("Something went wrong.");
        } finally {
            setLoading(false);

            setTimeout(() => {
                setResult("");
            }, 4000);
        }
    };

    return (
        <section
            className={`contact-section ${darkMode ? "dark" : ""}`}
            id="contact"
        >
            <div className="contact-container">
                <span className="contact-tag">GET IN TOUCH</span>

                <h1>Let’s build something together.</h1>

                <p className="contact-description">
                    Whether it’s software engineering, embedded systems, mobile
                    development, or collaborative opportunities, feel free to
                    reach out.
                </p>

                <div className="social-links">
                    <a
                        href="https://www.linkedin.com/in/oluwafisayo-adabs-/"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="LinkedIn"
                    >
                        <i className="fa fa-linkedin"></i>
                    </a>

                    <a
                        href="https://github.com/fisayoadabs"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="GitHub"
                    >
                        <i className="fa fa-github"></i>
                    </a>
                </div>

                <form onSubmit={handleSubmit}>
                    <input
                        type="hidden"
                        name="access_key"
                        value="301bf9f6-8030-4c1f-8bce-60b8a235abf5"
                    />

                    <input
                        type="text"
                        name="name"
                        placeholder="Your Name"
                        required
                    />

                    <input
                        type="email"
                        name="email"
                        placeholder="Your Email"
                        required
                    />

                    <textarea
                        name="message"
                        placeholder="Your Message"
                        required
                    />

                    <button type="submit" disabled={loading}>
                        {loading ? "Sending..." : "Send Message"}
                    </button>

                    {result && <div className="form-result">{result}</div>}
                </form>
            </div>
        </section>
    );
}

export default Contact;